module.exports = __webpack_public_path__ + "img/eletrodutoAcessorioFita.90ed65b0.png";